<template>
  <div class="common-template">
    <div class="common-template__title">
      <div>{{showTitle}}</div>
      <div :class="isPremium ? 'w214' : 'w225'">{{titleDescribe}}</div>
    </div>
    <div class="line"></div>
    <div class="common-template__list">
      <div v-for="(item) in showList" :key="item.id">
        <svg-icon class="icon" :name="item.icon"></svg-icon>
        <span>{{item.name}}</span>
      </div>
    </div>
    <common-button @click="goSub" v-if="$checkPermission(['admin', 'diamond']) && isPremium"
      class="started-button" type='primary'>UPGRADE TO PREMIUM</common-button>
  </div>
</template>

<script>
const config = {
  freemium() {
    return [
            {
              icon: 'icon-full-suceess',
              name: '10 Loads',
              id: 1,
            },
            {
              icon: 'icon-full-suceess',
              name: '30 Documents',
              id: 2,
            },
            {
              icon: 'icon-full-suceess',
              name: 'No Trucker Path Membership Included',
              id: 3,
            },
            {
              icon: 'icon-full-suceess',
              name: 'Limited Feature',
              id: 4,
            }
          ]
  },
  premium() {
    return [
            {
              icon: 'icon-full-suceess',
              name: 'Unlimited Loads',
              id: 1,
            },
            {
              icon: 'icon-full-suceess',
              name: 'Unlimited Documents',
              id: 2,
            },
            {
              icon: 'icon-full-suceess',
              name: 'Diamond Trucker Path Membership',
              id: 3,
            },
            {
              icon: 'icon-full-suceess',
              name: 'Accounting',
              id: 4,
            },
            {
              icon: 'icon-full-suceess',
              name: 'Permission Setting ',
              id: 5,
            }
          ]
  }
}
export default {
  name: 'common-template',
  props: {
    title: {
      type: String,
      default: 'Freemium'
    },
    source: {
      type: String,
      default: ''
    },
  },
  computed: {
    isPremium() {
      return this.title === 'Freemium' ? false : true
    },
    showTitle() {
      return this.isPremium ? 'COMMAND Premium' : 'Free Subscription'
    },
    titleDescribe() {
      return this.isPremium ? 'Recommended for active users and teams.' : 'Experience the basic functions of COMMAND for free.'
    },
    showList() {
      return config[this.isPremium ? 'premium' : 'freemium']()
    }
  },
  methods: {
    goSub() {
      this.$emit('close')
      this.$buriedPoints(18.13, {
          Source: this.source
      })
      this.$router.push({
        path: '/setting/subscription-and-billing-v2/manage'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.common-template {
  width: 271px;
  height: 414px;
  border: 1px solid #E7EBF3;
  border-radius: 6px;
  padding: 16px;
  .w225 {
    width: 100%;
  }
  .w214 {
    width: 100%;
  }
  &__title {
    margin-top: 20px;
    text-align: center;
    div {
      &:nth-child(1) {
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
        font-family: OpenSans;
      }
      &:nth-child(2) {
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        color: #7F8596;
        margin-top: 4px;
        font-family: OpenSans;
      }
    }
  }
  &__list {
    div {
      &:nth-child(3) {
        span {
          width: 230px;
          position: relative;
          left: 3px;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      margin-bottom: 8px;
      .icon {
        width: 16px;
        height: 16px;
      }
      span {
        margin-left: 6px;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #4C556C;
        font-family: OpenSans;
      }
    }
  }
  .line {
    width: 100%;
    height: 1px;
    flex: none;
    order: 2;
    margin: 0 auto;
    align-self: stretch;
    flex-grow: 0;
    margin: 32px 0;
    border-image-source: linear-gradient(90deg, rgba(231, 235, 243, 0) 0%, #D5DEEF 55.33%, rgba(231, 235, 243, 0) 101.17%);
    background: linear-gradient(90deg, rgba(231, 235, 243, 0) 0%, #D5DEEF 55.33%, rgba(231, 235, 243, 0) 101.17%);
  }
  .started-button {
    font-size: 12px;
    width: 224.5px;
    height: 32px;
    line-height: 32px;
    margin-top: 84px;
    margin-bottom: 4px;
    width: 100%;
  }
  /deep/ .common-button  {
    span {
      font-weight: 700;
      font-family: OpenSans;
    }
  }
}
</style>>
